import React from 'react';

import PropTypes from 'prop-types';

export default class PrintComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const { firstName, lastName, appId } = this.props;

    return (
      <div>
        <div
          style={{
            backgroundColor: '#FFF',
            height: '80rem',
            width: 'auto',
            position: 'absolute',
          }}
          id="printCover"
        />
        <img
          src={`https://cms.travpromobile.com/api/app/diploma?first_name=${firstName}&last_name=${lastName}&app_id=${appId}`}
          alt={`${firstName} ${lastName}`}
        />
      </div>
    );
  }
}

PrintComponent.propTypes = {
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string.isRequired,
  appId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
